import { TranslocoService } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { GetDocumentDto } from 'src/app/modules/documents/models/documents.model';
import { NotificationsActions } from 'src/app/modules/notifications/store/actions';
import { constants } from '../constants/constants';

export function sendReportSuccessNotification(
  store: Store,
  translocoService: TranslocoService,
  document: GetDocumentDto,
) {
  const message = translocoService.translate('text.generatingReportSuccessText', {
    name: document.name,
  });

  store.dispatch(
    NotificationsActions.showNotificationComponent({
      icon: constants.icons.greenTick,
      title: translocoService.translate('text.generatingReportSuccessTitle'),
      message,
    }),
  );
}

export function sendReportFailedNotification(
  store: Store,
  translocoService: TranslocoService,
  document: GetDocumentDto,
) {
  const message = translocoService.translate('text.generatingReportFailText', {
    name: document.name,
  });

  store.dispatch(
    NotificationsActions.showNotificationComponent({
      icon: constants.icons.redCross,
      title: translocoService.translate('text.generatingReportFailTitle'),
      duration: constants.notificationInfinityHideDelayKeyValue,
      message,
    }),
  );
}
